"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudConfigFileTypes = void 0;
var CloudConfigFileTypes;
(function (CloudConfigFileTypes) {
    CloudConfigFileTypes[CloudConfigFileTypes["YAML"] = 1] = "YAML";
    CloudConfigFileTypes[CloudConfigFileTypes["JSON"] = 2] = "JSON";
    CloudConfigFileTypes[CloudConfigFileTypes["TF"] = 3] = "TF";
})(CloudConfigFileTypes = exports.CloudConfigFileTypes || (exports.CloudConfigFileTypes = {}));
//# sourceMappingURL=types.js.map